import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { AuthPanel } from './auth-panel';
import { AuthShell } from './auth-shell';

export function LoginCard({ onAuthenticated }: { onAuthenticated: () => void }) {
  return (
    <AuthShell>
      <Card className="rise w-full max-w-sm shadow-lg [--card-spacing:--spacing(6)]">
        <CardHeader className="justify-items-center text-center">
          <img
            src="/assets/logo-nargus.png"
            alt="nargus"
            className="h-16 w-auto mix-blend-multiply dark:mix-blend-screen dark:invert"
          />
        </CardHeader>
        <CardContent>
          <AuthPanel onAuthenticated={onAuthenticated} />
        </CardContent>
      </Card>
    </AuthShell>
  );
}
